import warningTriangle from '@/assets/icons/warning-triangle.svg'
import type { EditorView, NodeView } from 'prosemirror-view'

/** A removable review marker participates in selection and undo like source chips. */
export function verificationNodeView(view: EditorView, getPos: () => number | undefined): NodeView {
  const dom = document.createElement('span')
  dom.contentEditable = 'false'
  dom.className = 'mx-0.5 inline-flex items-center gap-1 rounded border border-brand-neutral-300 bg-brand-neutral-200 px-1 text-xs text-brand-neutral-500'
  dom.title = 'We couldn’t confirm a supporting passage. Check this answer against the document.'
  const icon = document.createElement('span')
  icon.className = 'inline-block size-3.5 bg-current'
  icon.style.mask = `url(${JSON.stringify(warningTriangle)}) center / contain no-repeat`
  icon.setAttribute('aria-label', 'Needs manual verification')
  const remove = document.createElement('button')
  remove.type = 'button'
  remove.textContent = '×'
  remove.className = 'rounded px-0.5 hover:bg-brand-neutral-300 hover:text-brand-neutral-950 focus-visible:outline focus-visible:outline-brand-500'
  remove.setAttribute('aria-label', 'Remove verification warning')
  remove.onmousedown = (event) => event.preventDefault()
  remove.onclick = () => {
    const pos = getPos()
    if (!view.editable || pos === undefined) return
    view.dispatch(view.state.tr.delete(pos, pos + 1))
    view.focus()
  }
  dom.append(icon, remove)
  return {
    dom,
    stopEvent: (event) => event.target instanceof Element && Boolean(event.target.closest('button')),
    ignoreMutation: () => true,
  }
}
